import { types } from "../types/types";
const intitalState = {
    enquiries: [],
    enquiriesDetails: {},
};

const enquiriesReducer = (state = intitalState, action) => {
    switch (action.type) {
        case types.ENQUIRIES:
            return {
                ...state,
                enquiries: action.payload,
            };
        case types.ENQUIRIES_DETAILS:
            return {
                ...state,
                enquiriesDetails: action.payload,
            };
        default:
            return { ...state };
    }
};

export default enquiriesReducer;
